import { Span, theme } from '@ahmdigital/ui';
import Icon, { IconList } from '@ahmdigital/icons-web';

import { COVERAGE_INCLUSION } from '../../../../../constants';
import styles from './styles.module.sass';

const ICON_MAPPING = {
  excluded: {
    fill: theme.colors.red,
    name: 'cross-circle' as IconList,
  },
  included: {
    fill: theme.colors.green,
    name: 'tick-circle' as IconList,
  },
  optional: {
    fill: theme.colors.blue,
    name: 'plus-circle' as IconList,
  },
};

const TITLE_MAPPING = {
  [COVERAGE_INCLUSION.EXCLUDED]: 'Excluded',
  [COVERAGE_INCLUSION.INCLUDED]: 'Included',
  [COVERAGE_INCLUSION.OPTIONAL]: 'Optional',
};

type CellProps = {
  inclusionType: 'excluded' | 'included' | 'optional';
};

const Cell = ({ inclusionType }: CellProps) => (
  <Span className={styles.cell}>
    <Icon {...ICON_MAPPING[inclusionType]} size="small" />
    <Span className={styles.label}> {TITLE_MAPPING[inclusionType]}</Span>
  </Span>
);

export default Cell;
